var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridViewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.48438 2.41406H3.52604C3.08882 2.41406 2.73438 2.7685 2.73438 3.20573V7.16406C2.73438 7.60129 3.08882 7.95573 3.52604 7.95573H7.48438C7.9216 7.95573 8.27604 7.60129 8.27604 7.16406V3.20573C8.27604 2.7685 7.9216 2.41406 7.48438 2.41406Z",
    stroke: "white",
    strokeWidth: 1.40535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.1934 2.41406H12.235C11.7978 2.41406 11.4434 2.7685 11.4434 3.20573V7.16406C11.4434 7.60129 11.7978 7.95573 12.235 7.95573H16.1934C16.6306 7.95573 16.985 7.60129 16.985 7.16406V3.20573C16.985 2.7685 16.6306 2.41406 16.1934 2.41406Z",
    stroke: "white",
    strokeWidth: 1.40535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.1934 11.125H12.235C11.7978 11.125 11.4434 11.4794 11.4434 11.9167V15.875C11.4434 16.3122 11.7978 16.6667 12.235 16.6667H16.1934C16.6306 16.6667 16.985 16.3122 16.985 15.875V11.9167C16.985 11.4794 16.6306 11.125 16.1934 11.125Z",
    stroke: "white",
    strokeWidth: 1.40535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.48438 11.125H3.52604C3.08882 11.125 2.73438 11.4794 2.73438 11.9167V15.875C2.73438 16.3122 3.08882 16.6667 3.52604 16.6667H7.48438C7.9216 16.6667 8.27604 16.3122 8.27604 15.875V11.9167C8.27604 11.4794 7.9216 11.125 7.48438 11.125Z",
    stroke: "white",
    strokeWidth: 1.40535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewIcon);
export default __webpack_public_path__ + "static/media/GridViewIcon.101154062bea5aa49b553997287d9476.svg";
export { ForwardRef as ReactComponent };